/**
 * Emirates ID input formatter — masks `784YYYYXXXXXXXX` digit input as
 * `784-YYYY-XXXXXXX-X`. Mirrors Flutter
 * `emirates_id_input_formatter.dart` (and its 15-digit / 4-segment
 * layout).
 *
 * **MASKING ONLY.** No validation logic lives here:
 *   - No checksum (the 15th digit is technically a Luhn-style check
 *     but no validator ships against it on the React or Flutter side
 *     today; backend echo is authoritative).
 *   - No 784-prefix enforcement.
 *   - No "must-be-15-digits" guard — partial input is rendered as you
 *     type and the field can be saved short of 15 digits if the user
 *     wants (backend will 4xx if it cares).
 *
 * Validation, if/when it lands, belongs in a sibling utility that
 * consumers explicitly opt into. Keeping the formatter pure means
 * adding validation is a localised, reviewable change rather than a
 * side-effect ride-along.
 *
 * Consumers:
 *   - `identity-verification-section.tsx` (patient identity)
 *   - `guardian-section.tsx` (guardian identity)
 */
export function formatEmiratesId(raw: string): string {
  const digits = raw.replace(/\D+/g, '').slice(0, 15);
  if (digits.length <= 3) return digits;
  if (digits.length <= 7) return `${digits.slice(0, 3)}-${digits.slice(3)}`;
  if (digits.length <= 14) {
    return `${digits.slice(0, 3)}-${digits.slice(3, 7)}-${digits.slice(7)}`;
  }
  return `${digits.slice(0, 3)}-${digits.slice(3, 7)}-${digits.slice(7, 14)}-${digits.slice(14)}`;
}
